module.exports = __webpack_public_path__ + "img/three3Orange.b097758c.jpg";